var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandGoogleStyleWhite = function SvgBrandGoogleStyleWhite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.8 12.256a13 13 0 0 0-.204-2.295H12.032V14.3h6.037a5.16 5.16 0 0 1-2.238 3.385V20.5h3.624c2.121-1.953 3.345-4.83 3.345-8.244"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.032 23.216c3.029 0 5.567-1.004 7.423-2.716l-3.624-2.816c-1.005.673-2.29 1.072-3.799 1.072-2.92 0-5.393-1.974-6.276-4.625H2.01v2.906a11.21 11.21 0 0 0 10.023 6.18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.756 14.131a6.7 6.7 0 0 1-.351-2.13c0-.74.127-1.459.351-2.132V6.963H2.01A11.2 11.2 0 0 0 .816 12c0 1.81.434 3.523 1.193 5.037z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.032 5.245c1.647 0 3.126.566 4.288 1.676l3.217-3.215C17.594 1.894 15.056.784 12.032.784A11.21 11.21 0 0 0 2.01 6.963l3.747 2.906c.883-2.65 3.355-4.624 6.276-4.624"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandGoogleStyleWhite);
export { ForwardRef as ReactComponent };